import { NineBoxMock } from 'src/environments/features/nineBoxMock';

export class NineboxFeature {
	enabled: boolean;
	applyMock: boolean = false;
	showCorrelation: boolean;
	mock: NineBoxMock;
    invertedQuadrants: boolean;
    showPreCalibrationBackground: boolean;
    limitParticipantsComprimedView: number = 8;
    limitParticipantsExpandedView: number = 8;
	useCustomNineboxConfig: boolean= false;
	participantProperties: string[] = [
		'lineManager',
		'company',
		'businessGroup',
		'businessUnit',
		'country',
		'frontBackOffice',
		'job',
		'location',
		'rank',
		'segment',
		'legalEntity',
		'rankOpen',
		'sector1',
		'sector2',
		'sector3',
		'sector4',
	];

	constructor(feature: Partial<NineboxFeature> = null) {
		if (feature)
			Object.keys(feature).forEach(key => this[key] = feature[key]);

		this.mock = this.applyMock ? this._mock : ({} as any);
	}

	/*Define as propriedades que serão exibidas na visualização dos detalhes do participante*/


	private _mock: NineBoxMock = {
		axisConfiguration: {
			questionConfigId: null,
			questionGroupId: null,
			xAxis: {
				processId: null,
				name: 'DESEMPENHO AVALIAÇÃO DE COMPETÊNCIA',
				axisLabels: [],
				values: [{ 'min': 0, 'max': 4 }, { 'min': 4, 'max': 7 }, { 'min': 7, 'max': 10 }]
			},
			yAxis: {
				processId: null,
				name: 'POTENCIAL DE EVOLUÇÃO',
				axisLabels: [],
				values: [{ 'min': 0, 'max': 1 }, { 'min': 1, 'max': 2 }, { 'min': 2, 'max': 3 }]
			},
			colors: [
				{ 1: '#D9D9D9' },
				{ 2: '#B7DEE8' },
				{ 3: '#B7DEE8' },
				{ 4: '#B7DEE8' },
				{ 5: '#C9F791' },
				{ 6: '#C9F791' },
				{ 7: '#B7DEE8' },
				{ 8: '#C9F791' },
				{ 9: '#C9F791' },
			]
		},
		participants: [
			{
				'userId': '27030a1e-54f1-489a-80ad-50054d26b50a',
				'email': 'email-1@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 1',
				'imageUrl': 'https://i.pravatar.cc/150?img=1',
				'lineManager': 'lineManager 54f1',
				'notes': '',
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 7.45,
				'quadrantYAxisValue': 1.27,
				'quadrantId': 6
			},
			{
				'userId': 'cfa038ca-9914-4b40-b2a2-95cbd9d12ea5',
				'email': 'email-2@exemplo.com.br',
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 2',
				'imageUrl': 'https://i.pravatar.cc/150?img=2',
				'lineManager': 'lineManager 9914',
				'notes': null,
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 0.19,
				'quadrantYAxisValue': 0.1,
				'quadrantId': 1,
				'modifiedQuadrantId': 9
			},
			{
				'userId': '4369a0ff-b861-4292-b9a4-aca5646defc1',
				'email': 'email-3@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 3',
				'imageUrl': 'https://i.pravatar.cc/150?img=3',
				'lineManager': 'lineManager 4292',
				'notes': null,
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 0.3,
				'quadrantYAxisValue': 3,
				'quadrantId': 7
			},
			{
				'userId': 'f517c03f-bc7a-4fbd-a70b-1348c0ca8131',
				'email': 'email-4@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 4',
				'imageUrl': 'https://i.pravatar.cc/150?img=4',
				'lineManager': 'lineManager 4fbd',
				'notes': null,
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 6.95,
				'quadrantYAxisValue': 0.43,
				'quadrantId': 2
			},
			{
				'userId': '6b413c90-e577-4e33-b0c4-06825ae00e21',
				'email': 'email-5@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 5',
				'imageUrl': 'https://i.pravatar.cc/150?img=5',
				'lineManager': 'lineManager 4e33',
				'notes': 'EX',
				'inReview': true,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 1.04,
				'quadrantYAxisValue': 1.71,
				'quadrantId': 4
			},
			{
				'userId': '9db54fda-8629-473d-9735-516e4279aee1',
				'email': 'email-6@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 6',
				'imageUrl': 'https://i.pravatar.cc/150?img=6',
				'lineManager': 'lineManager 473d',
				'notes': null,
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 2.78,
				'quadrantYAxisValue': 1.85,
				'quadrantId': 4
			},
			{
				'userId': 'b2d08c8d-b529-41f7-b90e-bf1a62bdd015',
				'email': 'email-7@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 7',
				'imageUrl': 'https://i.pravatar.cc/150?img=7',
				'lineManager': 'lineManager 41f7',
				'notes': 'EX',
				'inReview': true,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 6.89,
				'quadrantYAxisValue': 1.66,
				'quadrantId': 5
			},
			{
				'userId': 'a1ba6b95-b626-4afe-8487-4ee771a375e1',
				'email': 'email-8@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 8',
				'imageUrl': 'https://i.pravatar.cc/150?img=8',
				'lineManager': 'lineManager 4afe',
				'notes': '',
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 9.02,
				'quadrantYAxisValue': 2.94,
				'quadrantId': 9
			},
			{
				'userId': 'e5226d01-0626-4f58-a585-ab421c1e2840',
				'email': 'email-9@exemplo.com.br',
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 9',
				'imageUrl': 'https://i.pravatar.cc/150?img=9',
				'lineManager': 'lineManager 4f58',
				'notes': null,
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 1.35,
				'quadrantYAxisValue': 0.79,
				'quadrantId': 1,
				'modifiedQuadrantId': 6
			},
			{
				'userId': '5616f162-c7ca-4860-a3de-8efe8eb2c900',
				'email': 'email-10@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 10',
				'imageUrl': 'https://i.pravatar.cc/150?img=10',
				'lineManager': 'lineManager 4860',
				'notes': '',
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 5.36,
				'quadrantYAxisValue': 1.11,
				'quadrantId': 5
			},
			{
				'userId': 'ea6d4039-adb5-4feb-b012-6c87d2f62f0a',
				'email': 'email-11@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 11',
				'imageUrl': 'https://i.pravatar.cc/150?img=11',
				'lineManager': 'lineManager 4feb',
				'notes': null,
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 6.57,
				'quadrantYAxisValue': 2.01,
				'quadrantId': 8
			},
			{
				'userId': 'aad4bb9c-e160-47f8-8e96-0f3ce214398c',
				'email': 'email-12@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 12',
				'imageUrl': 'https://i.pravatar.cc/150?img=12',
				'lineManager': 'lineManager 47f8',
				'notes': null,
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 7.17,
				'quadrantYAxisValue': 2.19,
				'quadrantId': 9
			},
			{
				'userId': 'e1a36767-b610-4f46-9fe4-8db61658c908',
				'email': 'email-13@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 13',
				'imageUrl': 'https://i.pravatar.cc/150?img=13',
				'lineManager': 'lineManager 4f46',
				'notes': null,
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 7.72,
				'quadrantYAxisValue': 0.55,
				'quadrantId': 3
			},
			{
				'userId': '4e18ec40-d5cb-4544-949b-c2f92962e7b0',
				'email': 'email-14@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 14',
				'imageUrl': 'https://i.pravatar.cc/150?img=14',
				'lineManager': 'lineManager 4544',
				'notes': null,
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 7.38,
				'quadrantYAxisValue': 1.41,
				'quadrantId': 6
			},
			{
				'userId': '7a837092-4b4c-4065-af30-048411490d1a',
				'email': 'email-15@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 15',
				'imageUrl': 'https://i.pravatar.cc/150?img=15',
				'lineManager': 'lineManager 4065',
				'notes': null,
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 3.41,
				'quadrantYAxisValue': 2.15,
				'quadrantId': 7
			},
			{
				'userId': '6ef740c6-3336-4cf4-ac83-7ec0da17598f',
				'email': 'email-16@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 16',
				'imageUrl': 'https://i.pravatar.cc/150?img=16',
				'lineManager': 'lineManager 4cf4',
				'notes': null,
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 2.57,
				'quadrantYAxisValue': 0.79,
				'quadrantId': 1
			},
			{
				'userId': '86cb6cb3-cf71-418e-9529-e30f536a0890',
				'email': 'email-17@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 17',
				'imageUrl': 'https://i.pravatar.cc/150?img=17',
				'lineManager': 'lineManager 418e',
				'notes': null,
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 4.96,
				'quadrantYAxisValue': 0.92,
				'quadrantId': 2
			},
			{
				'userId': '4f06ce95-a20e-417b-95ec-3f022555cf66',
				'email': 'email-18@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 18',
				'imageUrl': 'https://i.pravatar.cc/150?img=18',
				'lineManager': 'lineManager 417b',
				'notes': null,
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 8.65,
				'quadrantYAxisValue': 0.04,
				'quadrantId': 3
			},
			{
				'userId': '1cb07959-0a4e-41f7-8e6d-985a57f17803',
				'email': 'email-19@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 19',
				'imageUrl': 'https://i.pravatar.cc/150?img=19',
				'lineManager': 'lineManager 41f7',
				'notes': '',
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 9.55,
				'quadrantYAxisValue': 2.77,
				'quadrantId': 9
			},
			{
				'userId': 'e77a3758-2ee2-42da-8d88-7824789b2cb7',
				'email': 'email-20@exemplo.com.br',
				'modifiedQuadrantId': null,
				'showComment': null,
				'cycleParticipantId': null,
				'name': 'Usuari@ 20',
				'imageUrl': 'https://i.pravatar.cc/150?img=20',
				'lineManager': 'lineManager 42da',
				'notes': null,
				'inReview': false,
				'reviewNote': null,
				'rank': 'Analyst',
				'goalsFinalEvaluation': '',
				'principlesFinalEvaluation': '',
				'finalEvaluation': '',
				'originalFinalEvaluation': '',
				'finalEvaluationChanged': null,
				'quadrantXAxisValue': 0.11,
				'quadrantYAxisValue': 2.35,
				'quadrantId': 7
			}
		]
	};
}